module.exports = __webpack_public_path__ + "48cb1d97b490504c200f4220162b0a78.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/circles_content_to_commerce.png
// module id = 178
// module chunks = 0